import { Button, Stack, Typography } from "@mui/material";
import PromptDialog from "@entrilia/shared/components/dialog/PromptDialog.tsx";
import PromptDialogHeader from "@entrilia/shared/components/dialog/PromptDialogHeader.tsx";
import DialogButtons from "@entrilia/shared/components/DialogButtons.tsx";
import PublishDialogIcon from "@entrilia/shared/icons/PublishDialogIcon.tsx";
import UnpublishDialogIcon from "@entrilia/shared/icons/UnpublishDialogIcon.tsx";
import { Status } from "../../../../../api/types/svTypes.ts";
import StatusBox from "./status/StatusBox.tsx";

interface Props {
  templateName: string;
  currentStatus: Status;
  onClose: () => void;
  loading: boolean;
  onConfirm: (status: Status) => void;
}
export default function SwitchStatusDialog({ templateName, currentStatus, onClose, loading, onConfirm }: Props) {
  const title = currentStatus === Status.Live ? "Unpublish Template" : "Publish Template";
  const Icon = currentStatus === Status.Live ? UnpublishDialogIcon : PublishDialogIcon;

  return (
    <PromptDialog open={true} sx={{ width: 514, minHeight: 337, p: 0 }}>
      <PromptDialogHeader text={title} onClose={onClose} disabled={loading} />
      <Stack spacing={3} sx={{ alignItems: "center", textAlign: "center", p: 3 }}>
        <Icon sx={{ width: 80, height: 80 }} />
        <Stack spacing={2}>
          <Stack spacing={1} sx={{ alignItems: "center" }}>
            <Typography variant="h6">{`You are about to set the ${templateName} template status`}</Typography>
            <StatusBox status={currentStatus} />
          </Stack>
          <Typography color="secondary">
            {currentStatus === Status.Live
              ? "This template will be unpublished, making it inaccessible to all companies."
              : "All companies will have access to this template in the Report Templates section."}
          </Typography>
        </Stack>
      </Stack>
      <DialogButtons onCancel={onClose}>
        <Button
          variant="contained"
          disabled={loading}
          loading={loading}
          onClick={() => onConfirm(currentStatus === Status.Live ? Status.Draft : Status.Live)}
        >
          Confirm
        </Button>
      </DialogButtons>
    </PromptDialog>
  );
}
